<template>
    <b-form @submit.stop.prevent>
        <p v-if="isRegisteredUser" style="color: green"><b>Επιβεβαιωμένος</b></p>
        <p v-else style="color: red"><b>Μη επιβεβαιωμένος</b></p>
        <b-tabs pills card fill>
            <b-tab title="Ατομικά Στοιχεία" active>
                <b-form-row>
                    <b-col md="6">
                        <b-form-group label-for="name" label="Όνομα:"
                                      description="Το πεδίο δεν είναι επεξεργάσιμο">
                            <b-form-input id="name" v-model="selectedEfedros.efedros.efOnoma"
                                          readonly trim></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col>
                        <b-form-group label-for="surname" label="Επώνυμο:"
                                      description="Το πεδίο δεν είναι επεξεργάσιμο">
                            <b-form-input id="surname" v-model="selectedEfedros.efedros.efEpwnymo"
                                          readonly trim></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-form-row>
                <b-form-row>
                    <b-col md="6">
                        <b-form-group label-for="fatherName" label="Όνομα Πατρός:"
                        description="Να συμπληρωθεί το όνομα όπως αναγράφεται στην ταυτότητα">
                            <b-form-input id="fatherName" v-model="selectedEfedros.efedros.efOnomaP"
                                          :state="fatherNameValidation"
                                          :readonly="isDisabled" trim></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col>
                        <b-form-group label-for="motherName" label="Όνομα Μητρός:"
                        description="Να συμπληρωθεί το όνομα όπως αναγράφεται στην ταυτότητα">
                            <b-form-input id="motherName" v-model="selectedEfedros.efedros.efOnomaM"
                                          :state="motherNameValidation"
                                          :readonly="isDisabled" trim></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-form-row>
                <b-form-row>
                    <b-col md="6">
                        <b-form-group label-for="efsa" label="ΑΣΜ:"
                                      description="Το πεδίο δεν είναι επεξεργάσιμο">
                            <b-form-input id="efsa" readonly trim
                                          v-bind:value="selectedEfedros.efedros.efSa">
                            </b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col>
                        <b-form-group label-for="afm" label="ΑΦΜ:"
                                      description="Το πεδίο δεν είναι επεξεργάσιμο">
                            <b-form-input id="afm" readonly trim
                                          v-bind:value="selectedEfedros.afm.efAfm">
                            </b-form-input>
                        </b-form-group>
                    </b-col>
                </b-form-row>
                <b-form-row>
                    <b-col>
                        <b-form-group label-for="amka" label="ΑΜΚΑ:">
                            <b-form-input id="amka" :state="amkaValidation"
                                          v-model="selectedEfedros.afm.efAmka"
                                          :readonly="isDisabled || !isRegisteredUser">
                            </b-form-input>
                            <b-form-invalid-feedback :state="amkaValidation">
                                Το ΑΜΚΑ πρέπει να αποτελείται από 11 ψηφία
                            </b-form-invalid-feedback>
                        </b-form-group>
                    </b-col>
                    <b-col md="6">
                        <b-form-group label-for="email" label="E-mail">
                            <b-form-input id="email" :state="emailState"
                                          v-model="selectedEfedros.afm.efEmail"
                                          :readonly="isDisabled || !isRegisteredUser">
                            </b-form-input>
                            <b-form-invalid-feedback v-if="!emailValidation">
                                Μη έγκυρο email
                            </b-form-invalid-feedback>
                            <b-form-invalid-feedback v-if="!emailVerificationValidation">
                                Μη επιβεβαιωμένο email
                            </b-form-invalid-feedback>
                        </b-form-group>
                    </b-col>
                </b-form-row>
                <b-form-row>
                    <b-col md="6">
                        <b-form-group label-for="tel1" label="Σταθερό Τηλέφωνο" :invalid-feedback="tel1Validation.msg">
                            <b-form-input id="tel1"
                                          v-model="phone" :state="tel1Validation.state"
                                          :readonly="isDisabled"></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col>
                        <b-form-group label-for="tel2" label="Κινητό Τηλέφωνο"
                                      :invalid-feedback="tel2Validation.msg">
                            <b-form-input id="tel2" :state="tel2Validation.state"
                                          v-model="mobilePhone" :readonly="isDisabled"></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-form-row>
                <b-form-row>
                    <b-col md="6">
                        <b-form-group label-for="education" label="Επίπεδο Μόρφωσης:">
                            <b-form-select :readonly="isDisabled" :state="universityValidation" id="education"
                                           :options="universities" value-field="sxolKwd" text-field="sxolLekt"
                                           :disabled="isDisabled"
                                           v-model="selectedEfedros.efedros.efSxol" class="form-control">
                            </b-form-select>
                        </b-form-group>
                    </b-col>
                </b-form-row>
            </b-tab>
            <b-tab title="Στοιχεία Τόπου Διαμονής (Ελλάδος)">
                <p>
                    <b-form-row>
                        <b-col md="6">
                            <b-form-group label-for="streetName" label="Οδός τόπου διαμονής:">
                                <b-form-input id="streetName" :state="streetValidation"
                                              v-model="selectedEfedros.efedros.efOdos" :readonly="isDisabled">
                                </b-form-input>
                                <b-form-invalid-feedback :state="streetValidation">

                                </b-form-invalid-feedback>
                            </b-form-group>
                        </b-col>
                        <b-col>
                            <b-form-group label-for="streetNumber" label="Αριθμός τόπου διαμονής:">
                                <b-form-input id="streetNumber" :state="streetNumberValidation"
                                              v-model="selectedEfedros.efedros.efArith" :readonly="isDisabled">
                                </b-form-input>
                                <b-form-invalid-feedback :state="streetNumberValidation">
                                </b-form-invalid-feedback>
                            </b-form-group>
                        </b-col>
                    </b-form-row>
                    <b-form-row>
                        <b-col md="6">
                            <b-form-group label-for="placeOfResidence"
                                          label="Τόπος Διαμονής (Δημοτική κοινότητα, Καλλικρατικός Δήμος, Νομαρχία):">
                                <vue-bootstrap-typeahead id="placeOfResidence"
                                                         :readonly="isDisabled"
                                                         :state="placeOfResidenceValidation"
                                                         name="placeOfResidence"
                                                         :serializer="s => removeAccentsAndCapitalize(s.geoLekt)"
                                                         v-model="residenceSearchInfo.query"
                                                         :data="residenceSearchInfo.list"
                                                         :value="residenceSearchInfo.query"
                                                         @input="searchMunicipalities"
                                                         ref="typeahead"
                                                         :maxMatches="200"
                                                         @hit="setResidence($event)"
                                                         :loading="residenceSearchInfo.isLoading"
                                                         placeholder="Αναζήτηση"/>
                                <b-form-invalid-feedback :state="placeOfResidenceValidation">
                                    Μη έγκυρος τόπος διαμονής
                                </b-form-invalid-feedback>
                            </b-form-group>
                        </b-col>
                        <b-col>
                            <b-form-group label-for="postcode" label="Ταχυδρομικός Κώδικας Τόπου Διαμονής:">
                                <b-form-input id="postcode" :state="postcodeValidation"
                                              v-model="selectedEfedros.efedros.efTk" :readonly="isDisabled">
                                </b-form-input>
                                <b-form-invalid-feedback :state="postcodeValidation">
                                </b-form-invalid-feedback>
                            </b-form-group>
                        </b-col>
                    </b-form-row>
                    <b-form-row>
                        <b-col md="6">
                            <b-form-group label-for="policeDept"
                                          label="Αρμόδιο Αστυνομικό Τμήμα Τόπου Διαμονής:">
                                <b-form-select v-model="selectedEfedros.efedros.efAstKwd" id="policeDept"
                                               :options="policeDeptsOptions" value-field="astKodikosYphr"
                                               :state="policeDeptValidation"
                                               :disabled="isDisabled"
                                               text-field="astOnoma"
                                />
                            </b-form-group>
                        </b-col>
                        <b-col md="6">
                            <b-form-group label-for="mhtrwoArrenwn"
                                          label="Μητρώο Αρρένων (Νομαρχία, Δήμος, Δημοτικό Διαμέρισμα):">
                                <vue-bootstrap-typeahead id="mhtrwoArrenwn"
                                                         :readonly="isDisabled || !isRegisteredUser"
                                                         :state="mhtrwoArrenwnValidation"
                                                         name="mhtrwoArrenwn"
                                                         :serializer="s => removeAccentsAndCapitalize(s)"
                                                         v-model="maSearchInfo.query"
                                                         :data="maSearchInfo.list"
                                                         :value="maSearchInfo.query"
                                                         @input="searchMhtrArr"
                                                         ref="typeahead"
                                                         :maxMatches="200"
                                                         @hit="setMhtrwoArrenwn($event)"
                                                         :loading="maSearchInfo.isLoading"
                                                         placeholder="Αναζήτηση"/>
                                <b-form-invalid-feedback :state="mhtrwoArrenwnValidation">
                                    Μη έγκυρο μητρώο Αρρένων
                                </b-form-invalid-feedback>
                            </b-form-group>
                        </b-col>

                    </b-form-row>
                    <b-form-row>
                        <b-col md="6">
                            <b-form-group label-for="foreignResident" label="Είμαι Κάτοικος Εξωτερικού">
                                <b-form-checkbox id="foreignResident" v-model="isForeignResident"
                                                 :disabled="isDisabled">
                                </b-form-checkbox>
                            </b-form-group>
                        </b-col>
                    </b-form-row>
                    <b-form-row v-if="isForeignResident">
                        <b-col md="6">
                            <b-form-group label-for="proofOfResidence" label="Αποδεικτικό">
                                <b-form-file
                                    v-if="!isDisabled && !hasFile"
                                    v-model="file"
                                    :state="fileValidation"
                                    @input="uploadFile"
                                    placeholder="Επιλέξτε αρχείο pdf"
                                    drop-placeholder="Αφήστε το αρχείο εδώ."
                                    accept=".pdf"
                                ></b-form-file>
                                <b-form-row class="justify-content-md-center">
                                    <b-col md="4">
                                        <button type="button" class="btn btn-block btn-warning " v-if="hasFile"
                                                v-on:click="downloadFile">
                                            <font-awesome-icon :icon="['fas', 'download']"/>
                                            Κατέβασμα
                                        </button>
                                    </b-col>
                                </b-form-row>
                                <br>
                                <b-form-row class="justify-content-md-center">
                                    <b-col md="4">
                                        <button type="button" class="btn btn-block btn-danger"
                                                v-if="!isDisabled && hasFile"
                                                v-on:click="deleteFile">
                                            <font-awesome-icon :icon="['fas', 'trash']"/>
                                            Διαγραφή
                                        </button>
                                    </b-col>
                                </b-form-row>
                            </b-form-group>
                        </b-col>
                        <b-col>
                            <b-form-group label-for="countryOfResidence" label="Χώρα Διαμονής">
                                <b-form-select id="countryOfResidence"
                                               :state="countryValidation"
                                               v-model="selectedEfedros.exwteriko.exwtXwraKwd"
                                               :options="countriesOptions"
                                               :disabled="isDisabled"
                                ></b-form-select>
                            </b-form-group>
                        </b-col>
                    </b-form-row>
                </p>
            </b-tab>

            <b-tab title="Στοιχεία Εργασίας">
                <p>
                    <b-form-row>
                        <b-col md="6">
                            <b-form-group label-for="workplace"
                                          label="Τόπος Εργασίας (Δημοτική κοινότητα, Καλλικρατικός Δήμος, Νομαρχία):">
                                <vue-bootstrap-typeahead id="workplace"
                                                         name="workplace"
                                                         :readonly="isDisabled"
                                                         :serializer="s => removeAccentsAndCapitalize(s.geoLekt)"
                                                         v-model="workplaceSearchInfo.query"
                                                         :data="workplaceSearchInfo.list"
                                                         :value="workplaceSearchInfo.query"
                                                         @input="searchWorkMunicipalities"
                                                         ref="typeahead"
                                                         :maxMatches="200"
                                                         @hit="setWorkplace($event)"
                                                         :loading="workplaceSearchInfo.isLoading"
                                                         placeholder="Αναζήτηση"/>
                                <!--                                <b-form-invalid-feedback :state="workplaceValidation">-->
                                <!--                                    Μη έγκυρος τόπος διαμονής-->
                                <!--                                </b-form-invalid-feedback>-->
                            </b-form-group>
                        </b-col>
                        <b-col md="6">
                            <b-form-group label-for="job" label="Επάγγελμα">
                                <b-form-select id="job"
                                               :state="jobValidation"
                                               v-model="selectedEfedros.efedros.efEpagelma"
                                               :options="jobOptions"
                                               :disabled="isDisabled"
                                ></b-form-select>
                            </b-form-group>
                        </b-col>
                    </b-form-row>
                    <b-form-row>
                        <b-col md="6">
                            <b-form-group label-for="exeidikeysh" label="Εξειδίκευση">
                                <b-form-textarea
                                    id="exeidikeysh"
                                    v-model="selectedEfedros.efedros.efExeidikeysh"
                                    placeholder="Συμπληρώστε εδώ..."
                                    :state="exeidikeyshValidation"
                                    rows="3"
                                    :readonly="isDisabled"
                                ></b-form-textarea>
                            </b-form-group>
                        </b-col>
                    </b-form-row>
                </p>
            </b-tab>

            <b-tab title="Σωματομετρικά Στοιχεία">
                <p>
                    <b-form-row>
                        <b-col md="6">
                            <b-form-group label-for="weight" label="Βάρος (kg):"
                                          :description = "descriptionMessage">
                                <b-form-input id="weight" type="number" min="0" :state="weightValidation"
                                              v-model="selectedEfedros.swmatometrika.swmaBaros"
                                              :readonly="isDisabled"></b-form-input>
                                <b-form-invalid-feedback :state="weightValidation">
                                    Μη αποδεκτό βάρος
                                </b-form-invalid-feedback>
                            </b-form-group>
                        </b-col>
                        <b-col>
                            <b-form-group label-for="height" label="Ύψος (cm):"
                                          :description="descriptionMessage">
                                <b-form-input id="height" type="number" min="0" :state="heightValidation"
                                              v-model="selectedEfedros.swmatometrika.swmaYpsos"
                                              :readonly="isDisabled"></b-form-input>
                                <b-form-invalid-feedback :state="heightValidation">
                                    Μη αποδεκτό ύψος
                                </b-form-invalid-feedback>
                            </b-form-group>
                        </b-col>
                    </b-form-row>
                    <b-form-row>
                        <b-col md="6">
                            <b-form-group label-for="chestPerimeter" label="Περιφέρεια Στήθους (cm):"
                                          :description="descriptionMessage">
                                <b-form-input id="chestPerimeter" type="number" min="0"
                                              :state="chestValidation"
                                              v-model="selectedEfedros.swmatometrika.swmaPerifSththoys"
                                              :readonly="isDisabled"></b-form-input>
                                <b-form-invalid-feedback :state="chestValidation">
                                    Μη αποδεκτή περιφέρεια στήθους
                                </b-form-invalid-feedback>
                            </b-form-group>
                        </b-col>
                        <b-col>
                            <b-form-group label-for="waistPerimeter" label="Περιφέρεια Μέσης (cm):"
                                          :description="descriptionMessage">
                                <b-form-input id="waistPerimeter" type="number" min="0"
                                              :state="waistValidation"
                                              v-model="selectedEfedros.swmatometrika.swmaPerifMeshs"
                                              :readonly="isDisabled"></b-form-input>
                                <b-form-invalid-feedback :state="waistValidation">
                                    Μη αποδεκτή περιφέρεια μέσης
                                </b-form-invalid-feedback>
                            </b-form-group>
                        </b-col>
                    </b-form-row>
                    <b-form-row>

                        <b-col md="6">
                            <b-form-group label-for="neckPerimeter" label="Περιφέρεια Λαιμού (cm):"
                                          :description="descriptionMessage">
                                <b-form-input id="neckPerimeter" type="number" min="0"
                                              :state="neckValidation"
                                              v-model="selectedEfedros.swmatometrika.swmaPerifLaimoy"
                                              :readonly="isDisabled"></b-form-input>
                                <b-form-invalid-feedback :state="neckValidation">
                                    Μη αποδεκτή περιφέρεια λαιμού
                                </b-form-invalid-feedback>
                            </b-form-group>
                        </b-col>
                        <b-col>
                            <b-form-group label-for="crotchLength" label="Μήκος Καβάλου (cm):"
                                          :description="descriptionMessage">
                                <b-form-input id="crotchLength" type="number" min="0"
                                              :state="crotchValidation"
                                              v-model="selectedEfedros.swmatometrika.swmaMhkosKavaloy"
                                              :readonly="isDisabled"></b-form-input>
                                <b-form-invalid-feedback :state="crotchValidation">
                                    Μη αποδεκτό μήκος καβάλου
                                </b-form-invalid-feedback>
                            </b-form-group>
                        </b-col>
                    </b-form-row>
                    <b-form-row>
                        <b-col md="6">
                            <b-form-group label-for="shoeSize" label="Νούμερο Παπουτσιού:"
                                          :description= "descriptionMessage">
                                <b-form-input v-model="selectedEfedros.swmatometrika.swmaMhkosPelmatos"
                                              :readonly="isDisabled"
                                              :state="shoeSizeValidation"></b-form-input>
                                <b-form-invalid-feedback :state="shoeSizeValidation">
                                    Μη έγκυρο νούμερο παπουτσιού
                                </b-form-invalid-feedback>
                            </b-form-group>
                        </b-col>
                    </b-form-row>
                </p>
            </b-tab>
          <b-tab title="Γίνε Ενεργός Έφεδρος">
            <div class="d-flex align-items-center justify-content-">
            <label class="mr-3 text-left" for="activeReservist">&nbsp;Επιθυμώ να ενταχθώ στο θεσμό του Ενεργού Εφέδρου και να συμμετέχω σε εκπαιδεύσεις στη Μονάδα που ανήκω επιστρατευτικά ή σε Κέντρο Μετεκπαίδευσης Εφεδρείας.</label>
              <b-form-checkbox
                     id="activeReservist"
                     v-model="selectedEfedros.efedros.activeReservist"
                     :disabled="isActiveReservistLocked"
                     class="ml-3">
              </b-form-checkbox>
            </div>
            <br>
            <div class="d-flex align-items-center justify-content-between">
              <label class="mr-3" for="useSkills">&nbsp;Δύναμαι να διαθέσω δεξιότητες - εξειδικεύσεις που κατέχω, στη διάθεση των Ενόπλων Δυνάμεων, από την περίοδο της ειρήνης.</label>
              <b-form-checkbox
                     id="useSkills"
                     v-model="selectedEfedros.efedros.useSkills"
                :disabled="!selectedEfedros.efedros.activeReservist"
                     class="ml-3">
              </b-form-checkbox>
            </div>
            <!-- Show only if isChecked is true -->
            <div v-if="selectedEfedros.efedros.useSkills">
              <br>
              <b-form-row>
                <b-col md="6">
                  <b-form-group label-for="expertiseArea" label="Τομέας Εξειδίκευσης">
                    <b-form-select id="expertiseArea"
                                   v-model="selectedEfedros.efedros.expertiseArea"
                                   :options="expertiseAreaOptions"
                                   :disabled="isDisabled"
                    ></b-form-select>
                  </b-form-group>
                </b-col>
                <!-- Second Input: Conditional -->
                <b-col>
                  <b-form-group label-for="expertiseSkill" label="Ειδικότητα - Δεξιότητα">

                    <!-- Show dropdown when expertiseArea !== 7 -->
                    <b-form-select
                        v-if="selectedEfedros.efedros.expertiseArea !== 7"
                        id="expertiseSkill"
                        v-model="selectedEfedros.efedros.expertiseSkill"
                        :options="filteredSkillOptions"
                        :disabled="isDisabled"
                    ></b-form-select>

                    <!-- Show textarea when expertiseArea === 7 -->
                    <b-form-textarea
                        v-else
                        id="expertiseSkill"
                        v-model="expertiseSkillComputed"
                        placeholder="Συμπληρώστε εδώ..."
                        rows="3"
                        :readonly="isDisabled"
                    ></b-form-textarea>

                  </b-form-group>
                </b-col>
              </b-form-row>
              <b-form-group label-for="skillDescr" label="Περιγράψτε τις δεξιότητες που επιλέξατε πιο πάνω.">
                <b-form-textarea
                    id="skillDescr"
                    v-model="selectedEfedros.efedros.skillDesc"
                    placeholder="π.χ. Ιατρός με ειδικότητα ........, σπουδές ...... κλπ"
                    rows="3"
                    :readonly="isDisabled"
                ></b-form-textarea>
              </b-form-group>

            </div>
            <br>
            <div class="d-flex align-items-center justify-content-between">
              <label class="'mr-3'" for="agreement">&nbsp;Συναινώ στην επεξεργασία και διαχείριση των προσωπικών μου δεδομένων, για την ένταξή μου στο θεσμό του Ενεργού Εφέδρου.</label>
              <br>
              <b-form-checkbox
                  id="agreement"
                  :state="agreementValidation"
                  v-model="selectedEfedros.efedros.agreement"
                  :disabled="!selectedEfedros.efedros.activeReservist || isActiveReservistLocked"
                  class="ml-3">
              </b-form-checkbox>
            </div>
            <p v-if="agreementValidation === false && selectedEfedros.efedros.activeReservist" class="text-danger mt-1">
              Πρέπει να συναινέσετε για να συνεχίσετε.
            </p>
            <b-alert v-if="isActiveReservistLocked" show variant="info" class="mt-3">
              Είστε ήδη εγγεγραμμένος ως Ενεργός Έφεδρος. Για την απενεργοποίηση της Ενεργής Εφεδρείας, παρακαλείστε να στείλετε email στο <strong>des-mo[AT]army.gr</strong>
            </b-alert>
            <b-alert v-else show variant="warning" class="mt-3">
              Μετά την ενεργοποίηση της Ενεργής Εφεδρείας, για την απενεργοποίησή της παρακαλείστε να στείλετε email στο <strong>des-mo[AT]army.gr</strong>
            </b-alert>
          </b-tab>
        </b-tabs>
    </b-form>
</template>

<script>
import {HTTP} from "@/main";
import {Structs} from "@/structs";
import {debounce} from 'lodash';
import axios from "axios";

export default {
    name: "UserDetailsForm",
    model: {
        prop: ['selectedEfedros', 'isDisabled'],
        event: ['update:error', 'update:success']
    },
    props: {
        isDisabled: Boolean,
        selectedEfedros: Structs.SimpleUser(),
    },
    data() {

        return {
            descriptionMessage: "Η τιμή 0 ισοδυναμεί με τιμή που δεν έχει προσδιοριστεί και πρέπει να συμπληρωθεί",
            phone: "",
            mobilePhone: "",
            universities: [],
            countriesOptions: [{value: null, text: "---Επιλέξτε---"}],
            jobOptions: [{value: null, text: "---Επιλέξτε---"}],
            isForeignResident: false,
            file: null,
            hasFile: false,
            maSearchInfo: Structs.SearchInfo(),
            residenceSearchInfo: Structs.SearchInfo(),
            workplaceSearchInfo: Structs.SearchInfo(),
            policeDeptsOptions: [],
            isChecked: false,
            expertiseAreaOptions: [],
            skillOptionsByArea: {},
                        backendActiveReservist: false,
            selectedEfedros: {
              user: {
                expertiseArea: null,
                expertiseSkill: null
              }
            }
        };
    },

    created() {
        this.syncBackendActiveReservistLock();
        this.getCountries();
        this.getJobs();
        this.fetchExpertiseArea();
        this.getUniversities(this.$store.getters.getToken);
        this.getPoliceDepts();

        if (this.isRegisteredUser) {
            this.initRegisteredUser();
        }

        if (this.selectedEfedros.thlefwna != null) {
            this.selectedEfedros.thlefwna.forEach((val) => {
                if (val.thlAa === 1) {
                    this.phone = val.thlArith;
                } else if (val.thlAa === 2) {
                    this.mobilePhone = val.thlArith;
                }
            })
        }

        if (this.selectedEfedros.exwteriko.exwtXwraKwd != null) {
            this.isForeignResident = true;
        }
        if (this.selectedEfedros.exwteriko.dikaiologhtikaKwd != null) {
            this.hasFile = true;
        }

        if (this.selectedEfedros.efedros.diavMeeGeoByEfGeoDiam) {
            let place = this.selectedEfedros.efedros.diavMeeGeoByEfGeoDiam
            this.residenceSearchInfo.query = place.geoOnoma + ", " +
                place.geoKallikraths + ", " + place.geoNomos
        }

        if (this.selectedEfedros.efedros.diavMeeGeoByGeoAmErgasias) {
            let place = this.selectedEfedros.efedros.diavMeeGeoByGeoAmErgasias
            this.workplaceSearchInfo.query = place.geoOnoma + ", " +
                place.geoKallikraths + ", " + place.geoNomos
        }

        if (!this.isValid) {
            this.toast('Κάποια από τα στοιχεία του Έφεδρου δεν είναι σωστά. Παρακαλώ ελέγξτε όλες τις ενότητες.')
        }
    },
    computed: {
      filteredSkillOptions() {
        const areaId = this.selectedEfedros.efedros.expertiseArea;
        return this.skillOptionsByArea[areaId] || [];
      },
      expertiseSkillComputed: {
        get() {
          const val = this.selectedEfedros.efedros.expertiseSkill;
          return val && val.length > 2 ? val : null;
        },
        set(newValue) {
          this.selectedEfedros.efedros.expertiseSkill = newValue;
        }
      },
      agreementRequired() {
        return this.selectedEfedros.efedros.activeReservist && !this.selectedEfedros.efedros.agreement;
      },
        isRegisteredUser() {
            // If this.selectedEfedros.user is not null, we can safely assume
            // that this.selectedEfedros.afm is also not null
            return !!this.selectedEfedros.user && this.selectedEfedros.user.isVerified;
        },
        isValid() {

            let valid = false;

            // cast to boolean with !!
            valid = !!(
                this.fileValidation &&
                this.countryValidation &&
                this.motherNameValidation &&
                this.fatherNameValidation &&
                this.tel1Validation.state === null ? true : this.tel1Validation.state &&
                this.tel2Validation.state &&
                this.shoeSizeValidation &&
                this.streetValidation &&
                this.streetNumberValidation &&
                this.postcodeValidation &&
                this.weightValidation &&
                this.heightValidation &&
                this.chestValidation &&
                this.waistValidation &&
                this.crotchValidation &&
                this.neckValidation &&
                this.placeOfResidenceValidation &&
                this.policeDeptValidation &&
                this.exeidikeyshValidation &&
                this.agreementValidation
            );

            if (this.isRegisteredUser)
              valid = valid && this.emailValidation && this.amkaValidation && this.mhtrwoArrenwnValidation

            return valid;
        },

        weightValidation() {
            return (this.selectedEfedros.swmatometrika.swmaBaros >= 40);
        },
        heightValidation() {
            return (this.selectedEfedros.swmatometrika.swmaYpsos >= 150);
        },
        afmValidation() {
            // check if afm contains exactly 9 digits
            return (/^\d+$/.test(this.selectedEfedros.afm.efAfm) && this.selectedEfedros.afm.efAfm.length === 9);
        },
        chestValidation() {
            return (this.selectedEfedros.swmatometrika.swmaPerifSththoys > 0);
        },
        waistValidation() {
            return (this.selectedEfedros.swmatometrika.swmaPerifMeshs > 0);
        },
        neckValidation() {
            return (this.selectedEfedros.swmatometrika.swmaPerifLaimoy > 0);

        },
        crotchValidation() {
            return (this.selectedEfedros.swmatometrika.swmaMhkosKavaloy > 0);
        },
        amkaValidation() {
          if (!this.isRegisteredUser)
            return null
          else
            // check if amka contains exactly 11 digits
            return (/^\d+$/.test(this.selectedEfedros.afm.efAmka) && this.selectedEfedros.afm.efAmka.length === 11);
        },
        emailState() {
          return this.emailValidation && this.emailVerificationValidation
        },
        emailValidation() {
          if (!this.isRegisteredUser)
            return null
          else
            return !this.selectedEfedros.afm.efEmail ? false :
                (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.selectedEfedros.afm.efEmail))
                && this.selectedEfedros.afm.efEmail.length <= 255;
        },
        emailVerificationValidation() {
           return this.$store.getters.user.isEmailVerified;
        },
        shoeSizeValidation() {
            return (this.selectedEfedros.swmatometrika.swmaMhkosPelmatos >= 30 && this.selectedEfedros.swmatometrika.swmaMhkosPelmatos <= 60);
        },

        streetValidation() {
            return !!this.selectedEfedros.efedros.efOdos;
        },
        countryValidation() {
            return (!this.isForeignResident || (this.isForeignResident && !!this.selectedEfedros.exwteriko.exwtXwraKwd));
        },
        jobValidation() {
            return !!this.selectedEfedros.efedros.efEpagelma;
        },
        motherNameValidation() {
            return (/^[A-Za-zΑ-Ωα-ωίϊΐόάέύϋΰήώΆΈΊΌΎΏΉ\s$]+$/.test(this.selectedEfedros.efedros.efOnomaM));
        },
        fatherNameValidation() {
            return (/^[A-Za-zΑ-Ωα-ωίϊΐόάέύϋΰήώΆΈΊΌΎΏΉ\s$]+$/.test(this.selectedEfedros.efedros.efOnomaP));
        },
        exeidikeyshValidation() {
            return (!!this.selectedEfedros.efedros.efExeidikeysh) || (!!this.selectedEfedros.efedros.efExeidikeysh && this.selectedEfedros.efedros.efExeidikeysh.length <= 500);
        },
        streetNumberValidation() {
            return true; //TODO
        },
        postcodeValidation() {
            return (/^[a-zA-Z0-9]{1,10}$/.test(this.selectedEfedros.efedros.efTk));
        },
        fileValidation() {
            return !this.isForeignResident || (this.isForeignResident && (this.file || this.hasFile));
        },
        universityValidation() {
            return !!this.selectedEfedros.efedros.efSxol;
        },
        policeDeptValidation() {
            return !!this.selectedEfedros.efedros.efAstKwd;
        },
        tel1Validation() {
            if (this.phone == null || this.phone === '') {
                return {state: null};
            }

            if (this.phone === this.mobilePhone) {
                return {state: false, msg: "Το κινητό και το σταθερό τηλέφωνο πρέπει να διαφέρουν"};
            }

            return /^\d{10,14}$/.test(this.phone) ? {state: true, msg: null} : {
                state: false,
                msg: "Μη έγκυρος αριθμός τηλεφώνου"
            };
        },
        tel2Validation() {
            if (!this.mobilePhone) {
                return {state: false};
            }

            if (this.phone === this.mobilePhone) {
                return {state: false, msg: "Το κινητό και το σταθερό τηλέφωνο πρέπει να διαφέρουν"};
            }

            return /^\d{10,14}$/.test(this.mobilePhone) ? {state: true, msg: null} : {
                state: false,
                msg: "Μη έγκυρος αριθμός τηλεφώνου"
            };
        },
        mhtrwoArrenwnValidation() {
          if (!this.isRegisteredUser)
            return null
          else
            return !(this.maSearchInfo.query == null || this.maSearchInfo.query === ""
                || this.selectedEfedros.user.mhtrwoArrenwn == null ||
                this.selectedEfedros.user.mhtrwoArrenwn === "");
        },
        workplaceValidation() {
            return !(this.workplaceSearchInfo.query == null || this.workplaceSearchInfo.query === ""
                || this.selectedEfedros.efedros.geoAmErgasias == null ||
                this.selectedEfedros.efedros.geoAmErgasias === "");
        },
        placeOfResidenceValidation() {
            return !(this.residenceSearchInfo.query == null || this.residenceSearchInfo.query === ""
                || this.selectedEfedros.efedros.efGeoDiam == null ||
                this.selectedEfedros.efedros.efGeoDiam === "");
        },
      isActiveReservistLocked() {
                return this.backendActiveReservist;
      },
      agreementValidation(){
        return (this.selectedEfedros.efedros.activeReservist===false && this.selectedEfedros.efedros.agreement===false) ?
            true : !!this.selectedEfedros.efedros.agreement;
      },
    },

    watch: {
            selectedEfedros: {
                handler() {
                    this.syncBackendActiveReservistLock();
                },
                immediate: true
            },
        isForeignResident(val) {
            if (!val) {
                this.selectedEfedros.exwteriko.exwtXwraKwd = null;
                this.deleteFile()
            }
        },
      'selectedEfedros.efedros.activeReservist'(newValue) {
        if (!newValue) {
          this.selectedEfedros.efedros.useSkills = false;
          this.selectedEfedros.efedros.agreement = false;
        }
      },
      'selectedEfedros.efedros.useSkills'(newValue) {
        if (!newValue) {
          this.selectedEfedros.efedros.expertiseArea = 0;
          this.selectedEfedros.efedros.expertiseSkill = "";
          this.selectedEfedros.efedros.skillDesc = "";
        }
      },

    },

    methods: {
        syncBackendActiveReservistLock() {
            const efedros = this.selectedEfedros && this.selectedEfedros.efedros;
            this.backendActiveReservist = !!(efedros && efedros.activeReservist);
        },
        initRegisteredUser: function () {
            try {
                this.selectedEfedros.user.mhtrwoArrenwn = this.removeAccentsAndCapitalize(this.selectedEfedros.user.mhtrwoArrenwn);
                this.maSearchInfo.query = this.removeAccentsAndCapitalize(this.selectedEfedros.user.mhtrwoArrenwn);
            } catch (e) {
                console.log(e)
            }
        },
        setResidence(event) {
            this.selectedEfedros.efedros.efGeoDiam = event.geoAm
        },
        setWorkplace(event) {
            this.selectedEfedros.efedros.geoAmErgasias = event.geoAm
        },
        setMhtrwoArrenwn(event) {
          if (this.isRegisteredUser)
            this.selectedEfedros.user.mhtrwoArrenwn = event
        },
        removeAccentsAndCapitalize(text) {
            try {
                return text.toLowerCase().replaceAll('ά', 'α').replaceAll('έ', 'ε').replaceAll('ή', 'η').replaceAll('ί', 'ι').replaceAll('ό', 'ο').replaceAll('ύ', 'υ').replaceAll('ώ', 'ω').toUpperCase();
            } catch (e) {
                return '';
            }
        },
        searchMhtrArr: debounce(function (newQuery) {
            this.selectedEfedros.user.mhtrwoArrenwn = null
            this.maSearchInfo.isLoading = true
            this.$http.get(`/search/mhtr-arren?keyword=${newQuery}`)
                .then((res) => {
                    this.maSearchInfo.isLoading = false
                    this.maSearchInfo.list = res.data.responseData
                })
        }, 500),
        toast(msg) {
            this.$bvToast.toast(msg, {
                title: `Αδύνατη αποθήκευση`,
                variant: 'danger',
                solid: true
            });
        },
        searchMunicipalities: debounce(function (newQuery) {
            this.selectedEfedros.efedros.efGeoDiam = null
            let url = `/search/municipalities-by-keyword?keyword=${newQuery}`
            this.residenceSearchInfo.isLoading = true
            HTTP.get(url)
                .then(res => {
                    this.residenceSearchInfo.isLoading = false
                    this.residenceSearchInfo.list = res.data.responseData;
                })
        }),
        searchWorkMunicipalities: debounce(function (newQuery) {
            this.selectedEfedros.efedros.diavMeeGeoByGeoAmErgasias = null
            let url = `/search/municipalities-by-keyword?keyword=${newQuery}`
            this.workplaceSearchInfo.isLoading = true
            HTTP.get(url)
                .then(res => {
                    this.workplaceSearchInfo.isLoading = false
                    this.workplaceSearchInfo.list = res.data.responseData;
                })
        }),
        getPoliceDepts: function () {
            let url = `/search/police-depts`
            HTTP.get(url)
                .then(res => {
                    this.policeDeptsOptions = res.data;
                })
        },
        setMsg(status, msg) {
            this.message = msg;
            this.msgClass = status;
            this.msgVisible = true;
        },
        getCountries() {
            this.$store.dispatch('loading');
            let url = "/search/countries";
            HTTP.get(url).then(response => {
                var resp = response.data;
                resp.xwres.sort((c1, c2) => (c1.xwraLekt > c2.xwraLekt) ? 1 : (c1.xwraLekt > c2.xwraLekt) ? -1 : 0);
                for (const country of resp.xwres) {
                    this.countriesOptions.push({value: country.xwraKwd, text: country.xwraLekt});
                }
                this.$store.dispatch('stop_loading');
            }).catch(() => {
                this.$store.dispatch('stop_loading');
            });
        },
        fetchExpertiseArea(){
          this.$store.dispatch('loading');
          HTTP.get('/expertise-area/get-all')
              .then(response => {
                const areas = response.data;

                // 1. Set dropdown options
                this.expertiseAreaOptions = areas.map(area => ({
                  value: area.id,
                  text: area.expertiseName
                }));

                // 2. Map skills by area ID
                this.skillOptionsByArea = {};
                for (const area of areas) {
                  this.skillOptionsByArea[area.id] = area.expertiseSkills.map(skill => ({
                    value: skill.id,
                    text: skill.skillName
                  }));
                }

                this.$store.dispatch('stop_loading');
              })
              .catch(() => {
                this.$store.dispatch('stop_loading');
              });

        },
        getJobs() {
            this.$store.dispatch('loading');
            let url = "/search/jobs";
            HTTP.get(url).then(response => {
                var resp = response.data;
                resp.jobs.sort((c1, c2) => (c1.epagLekt > c2.epagLekt) ? 1 : (c1.epagLekt > c2.epagLekt) ? -1 : 0);
                for (const job of resp.jobs) {
                    this.jobOptions.push({value: job.epagKwd, text: job.epagLekt});
                }
                this.$store.dispatch('stop_loading');
            }).catch(() => {
                this.$store.dispatch('stop_loading');
            });
        },
        readFileAsync(file) {
            return new Promise((resolve, reject) => {
                let reader = new FileReader();

                reader.onload = () => {
                    resolve(reader.result);
                };

                reader.onerror = reject;

                reader.readAsArrayBuffer(file);
            })
        },
        uploadFile() {
            if (this.file) {
                this.$store.dispatch('loading');
                this.readFileAsync(this.file)
                    .then(value => {
                        HTTP.post("/users/" + this.selectedEfedros.efedros.efSa + "/upload-file", value, {
                            params: {
                                "file-type-id": 0,
                            },
                            headers: {
                                "Content-Type": "application/pdf"
                            }
                        })
                            .then((response) => {
                                let resp = response.data;
                                this.selectedEfedros.exwteriko.dikaiologhtikaKwd = resp.responseData.dikaiologhtikaKwd;
                                this.hasFile = true;
                            })
                            .catch((e) => console.error(e))
                            .finally(() => this.$store.dispatch('stop_loading'));
                    })
            }
        },
        downloadFile: function () {
            let url = "/users/download-file/" + this.selectedEfedros.exwteriko.dikaiologhtikaKwd;
            this.$store.dispatch('loading');
            this.$http({
                url: url,
                method: 'GET',
                responseType: 'blob',
            }).then((response) => {
                // this.$store.commit('set_token', response.headers.jwt);
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", "attachment.pdf");
                this.$store.dispatch('stop_loading');
                document.body.appendChild(link);
                link.click();
                link.parentNode.removeChild(link);
            }).catch((e) => {
                console.error(e);
                this.$store.dispatch('stop_loading');
            });
        },
        deleteFile: function () {
            this.file = null
            this.hasFile = false
            this.selectedEfedros.exwteriko.dikaiologhtikaKwd = null;
        },
        updateThlefwna: function () {
            let oldThlefwna = this.selectedEfedros.thlefwna
            this.selectedEfedros.thlefwna = []
            if (this.phone !== "") {
                let phone = Structs.Thlefwna();

                for (let i = 0; i < oldThlefwna.length; i++) {
                    let thlefwno = oldThlefwna[i]
                    if (thlefwno.thlAa === 1) {
                        phone.thlefwnoPk = thlefwno.thlefwnoPk;
                        break;
                    }
                }
                phone.thlAa = 1;
                phone.thlArith = this.phone;
                phone.efSa = this.selectedEfedros.efedros.efSa;
                this.selectedEfedros.thlefwna.push(phone);
            }

            if (this.mobilePhone !== "") {
                let mobile = Structs.Thlefwna()
                for (let i = 0; i < oldThlefwna.length; i++) {
                    let thlefwno = oldThlefwna[i]
                    if (thlefwno.thlAa === 2) {
                        mobile.thlefwnoPk = thlefwno.thlefwnoPk;
                        break;
                    }
                }
                mobile.thlAa = 2;
                mobile.thlArith = this.mobilePhone;
                mobile.efSa = this.selectedEfedros.efedros.efSa;
                this.selectedEfedros.thlefwna.push(mobile);
            }
        },
        getUniversities() {
            this.$store.dispatch('loading');
            let url = "/search/edu";
            HTTP.get(url).then(response => {
                var resp = response.data;
                this.universities = resp.universities;
                this.universities.sort((s1, s2) => (s1.sxolLekt > s2.sxolLekt) ? 1 : (s1.sxolLekt > s2.sxolLekt) ? -1 : 0);
                this.$store.dispatch('stop_loading');
            }).catch((error) => {
                console.error(error);
                this.$store.dispatch('stop_loading');
            });
        },
        updateUser() {
            this.selectedEfedros.user.email = this.selectedEfedros.afm.email;
            this.selectedEfedros.user.mobilePhone = this.mobilePhone;
            this.selectedEfedros.user.landlinePhone = this.phone;
        },
        update: function () {
            if (this.isValid) {
                this.$store.dispatch('loading');
                const isEmailUpdated = this.selectedEfedros.afm.efEmail !== this.$store.getters.user.email
                this.updateThlefwna();
                if (this.isRegisteredUser) {
                    this.updateUser();
                }

                this.selectedEfedros.exwteriko.efSa = this.selectedEfedros.efedros.efSa;

                if (!this.isForeignResident) {
                    this.selectedEfedros.exwteriko.exwtXw0raKwd = null;
                }
                let url = '/users/' + this.selectedEfedros.efedros.efSa;
                let headers = {
                    'Content-Type': 'application/json',
                };

                let ref = this;

                HTTP.post(url, this.selectedEfedros, {
                    headers: headers
                })
                    .then(response => {
                        let resp = response.data;
                        if (isEmailUpdated) {
                            this.$store.commit("setEmailVerified", false)
                        }
                        ref.$emit('update:success', resp.message);
                        this.$bvModal.hide('modal-1')
                        $('#ModalValidate').modal('hide');
                    })
                    .catch((error) => {
                        console.error(error);
                        var resp = error.response;
                        let msg = (resp.data.errorMessage) ? resp.data.errorMessage : resp.statusText;
                        ref.toast(msg);
                        ref.$emit('update:error', msg)
                    }).finally(() => {
                    this.$store.dispatch('stop_loading');
                });
            } else {
                this.toast('Κάποια από τα στοιχεία του Έφεδρου δεν είναι σωστά. Παρακαλώ ελέγξτε όλες τις ενότητες.');

                if (!this.mhtrwoArrenwnValidation) {
                    this.toast('Στο μητρώο αρρένων παρακαλώ πληκτρολογήστε τα αρχικά και επιλέξτε από την λίστα.');
                }

                if (!this.placeOfResidenceValidation) {
                    this.toast('Στον τόπο διαμονής παρακαλώ πληκτρολογήστε τα αρχικά και επιλέξτε από την λίστα.');
                }
            }
        },
    }
};
</script>

<style scoped>

</style>
